import React from "react";
import { Checkbox } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { ALL_WEEKDAYS } from "../../types/schedule";
export var WeekdayMaskEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    var selected = new Set(value.weekdays);
    var toggle = function (day) {
        var next = new Set(selected);
        if (next.has(day)) {
            next.delete(day);
        }
        else {
            next.add(day);
        }
        onChange({ weekdays: ALL_WEEKDAYS.filter(function (d) { return next.has(d); }) });
    };
    return (React.createElement("div", null, ALL_WEEKDAYS.map(function (day) { return (React.createElement(Checkbox, { key: day, label: formatMessage({
            id: "ui-br-legaldeposits.schedule.weekday.".concat(day),
        }), checked: selected.has(day), onChange: function () { return toggle(day); }, disabled: disabled })); })));
};
